import React, { useEffect, useState } from "react";

export const PopupComponent = (props: any) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    document.addEventListener("keyup", (ev) => {
      if (ev.code === "Escape" || ev.key === "Escape") {
        setShowPopup(false);
        props.popupCallback();
      }
    });

    return () => {
      document.removeEventListener("keyup", () => {
        setShowPopup(false);
      });
    };
  }, []);

  useEffect(() => {
    if (props.showPopup !== undefined && props.showPopup) {
      document.body.style.overflowY = "hidden";
      setShowPopup(props.showPopup);
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [props.showPopup]);

  if (!showPopup) {
    return null;
  }

  return (
    <div
      className="popup-backdrop modal show"
      onClick={(e: any) => {
        if (e.target.className.includes("popup-backdrop")) {
          setShowPopup(false);
          props.popupCallback();
        }
      }}
    >
      <div className="popup-container modal-dialog">
        <div className="popup-content modal-content">
          <button
            type="button"
            className="button btn-close popup-close"
            id="popup-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setShowPopup(false);
              props.popupCallback();
            }}
          >
            <span className="icon-close"></span>
          </button>

          {props.children}
        </div>
      </div>
    </div>
  );
}
export default PopupComponent;
